var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container h6 c-gray60 m-y-2 p-y-2"},[_vm._v("\n  Pro Referral verifies national and state-level licensing where applicable.\n  Some states either do not require licensing or license at the local level.\n  Before hiring a pro, we recommend contacting your local government to\n  confirm they are properly licensed.\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }